import { StandardEvents } from '@shopify/events';

const availability = 'filter.v.availability';
const preferenceKey = 'ac-collection-stock-preference';
const url = new URL(window.location.href);

/** @param {string} preference */
function remember(preference) {
  try {
    sessionStorage.setItem(preferenceKey, preference);
  } catch {
    // The explicit all-products URL still works when storage is unavailable.
  }
}

let preference = null;
try {
  preference = sessionStorage.getItem(preferenceKey);
} catch {
  // Default filtering does not require browser storage.
}

if (url.searchParams.get('ac_stock') === 'all') {
  remember('all');
} else if (!url.searchParams.has(availability) && preference !== 'all') {
  url.searchParams.set(availability, '1');
  url.searchParams.delete('page');
  window.location.replace(url.href);
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const shortcut = event.target.closest('.ac-stock-shortcut');
  if (!shortcut) return;
  remember(shortcut.getAttribute('aria-current') === 'true' ? 'all' : 'in-stock');
});

document.addEventListener(StandardEvents.collectionUpdate, () => {
  const current = new URL(window.location.href);
  remember(current.searchParams.has(availability) ? 'in-stock' : 'all');
});
